import {mapSetState, SetState} from "../../util/FormHandlers";
import React, {useMemo} from "react";
import {KeyVaultSelect} from "../../components/key-vault-select/KeyVaultSelect";
import {KeyVault} from "../../api/Model";

export interface MoveKeysDialogForm {
    targetVault: KeyVault;
}

export function MoveKeysDialog({form, setForm}: {
    form: MoveKeysDialogForm,
    setForm: SetState<MoveKeysDialogForm>,
}) {
    const setTargetVault = useMemo(
        () => mapSetState(setForm, 'targetVault'),
        [setForm]
    );

    return (
        <KeyVaultSelect
            sx={{mt: 2}}
            label="Target Key Vault"
            keyVault={form.targetVault}
            setKeyVault={setTargetVault}
            required
        />
    );
}